const SingleFixtureNews = () => {
  return <div>This is a news for the selected fixture!</div>;
};

export default SingleFixtureNews;
